import React from 'react';
import {useRouter} from "next/router";
import moment from 'moment';
import Image from "next/image";
import apiBack from "../../utils/apiBack";
import myLoader from "../../utils/myLoader";
import UseTranslations from "../../utils/useTranslations";
Index.layout = "UserLayout";

export default function Index({news}) {

    const { locale } = UseTranslations();

    return (
        <div className={"singular-news"}>
            {news &&
                <div className={"content"}>
                    <div className={"head"}>
                        <h1>{news?.[locale]?.title}</h1>
                        <p className={"date"}>{moment(news?.date).format("YYYY-MM-DD")}</p>
                    </div>
                    <div className={`content__image`}>
                        <Image src={news?.img} alt={"image"} width={694} height={390} objectFit={"cover"} loader={myLoader}/>
                    </div>
                    <div className={"content__text"} dangerouslySetInnerHTML={{__html: news?.[locale]?.description}}/>
                    <div className={'content__images'}>
                        {news?.images?.map(img => {
                                return <Image key={img} src={img} alt={"image"} width={694} height={390} objectFit={"cover"} loader={myLoader}/>
                            })}
                    </div>

                </div>
            }
        </div>
    );
}


export async function getServerSideProps({query}) {
    let data;

    try {
        data = (await apiBack.get(`news/${query.id}`)).data
    } catch (err) {
        console.log(err)
    }

    return {
        props: {
            query,
            news: data || [],
        },
    };
}

